module.exports = __webpack_public_path__ + "static/media/3pic.14cdfe2a.png";